export enum HistoryFilterEnum {
	HEALTH = 'HEALTH',
	TELEHEALTH = 'TELEHEALTH',
	EMERGENCY = 'EMERGENCY',
	SURGERY = 'SURGERY',
}
